import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Button, Row, Col, Form, Card, Space, DatePicker } from 'antd';
import Input from '../../../../ui/Input';
import TextArea from '../../../../ui/TextArea';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import Collapse, { Panel } from '../../../../ui/Collapse';
import { PlusOutlined } from '@ant-design/icons';
import PageContainer from '../../../../CSIComponents/PageContainer';
import './index.css';
import { propsTypes, itemType, detailDataType, policiesType } from './types';
import { Moment } from 'moment';
import moment from 'moment';
import { setData, post, getHelper } from './helpers';
import Loader from '../../../../Loading';

const dateFormat = 'MM/DD/YYYY';

/* const disabledDate = (current: moment.Moment) => {
  // Can not select days before today and today
  return current && current < moment().endOf('day');
}; */

const defaultRow = [
  {
    rulenumber: '',
    ruledescription: '',
    startdate: '',
    enddate: '',
    adultrollaway: '',
    childrollaway: '',
    cribcharge: '',
    extraadultcharge: '',
    extrachildcharge: '',
    servicecharge: '',
    maximumage: '',
    minimumage: '',
    startdatevalidation: '',
    enddatevalidation: '',
  },
];

const Forms = (props: any) => {
  const {
    isonEdit,
    validateData,
    item,
    i,
    dateError,
    rulenumber,
    detailData,
    setRuleNumber,
    ruledescription,
    setRuledescription,
    minimumage,
    setMinimumage,
    maximumage,
    setMaximumage,
    extraadultcharge,
    setExtraadultcharge,
    adultrollaway,
    setAdultrollaway,
    extrachildcharge,
    setExtrachildcharge,
    childrollaway,
    setChildrollaway,
    servicecharge,
    setServicecharge,
    cribcharge,
    setCribcharge,
    formTemp,
    onChangeStartDate,
    onChangeEndDate,
  } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    formTemp.current = [...formTemp.current, form];
  }, [form, formTemp]);

  return (
    <Form
      className={!isonEdit ? 'is-disabled-fields' : ''}
      layout="vertical"
      name={'basic-' + i}
      form={form}
      onValuesChange={() => validateData(form)}
      initialValues={{
        rulenumber: item?.rulenumber,
        ruledescription: item?.ruledescription,
        minimumage: item?.minimumage,
        maximumage: item?.maximumage,
        extraadultcharge: item?.extraadultcharge,
        adultrollaway: item?.adultrollaway,
        extrachildcharge: item?.extrachildcharge,
        childrollaway: item?.childrollaway,
        servicecharge: item?.servicecharge,
        cribcharge: item?.cribcharge,
        startdate: item?.startdate,
        enddate: item?.enddate,
      }}
    >
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item
            label="Start Date"
            name="startdate"
            hasFeedback
            help={
              dateError[i]
                ? dateError[i]['startVal'] === 'error'
                  ? 'Start date can not be a future day or empty if end date is not'
                  : ''
                : ''
            }
          >
            <Space direction="vertical">
              <DatePicker
                /* @ts-ignore */
                defaultValue={
                  item.startdate ? moment(item.startdate) : undefined
                }
                format="MM/DD/YYYY"
                onChange={(e) => onChangeStartDate(e, i)}
              />
            </Space>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="End Date"
            name="enddate"
            hasFeedback
            help={
              dateError[i]
                ? dateError[i]['endVal'] === 'error'
                  ? 'End date can not be a past date or start date is empty'
                  : ''
                : ''
            }
          >
            <Space direction="vertical">
              <DatePicker
                /* @ts-ignore */
                defaultValue={item.enddate ? moment(item.enddate) : undefined}
                format="MM/DD/YYYY"
                onChange={(e) => onChangeEndDate(e, i)}
              />
            </Space>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            label="Rule Number"
            name="rulenumber"
            rules={[
              {
                pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                message: 'This field should be a number',
              },
              {
                pattern: /^([0-9]{0,5})$/,
                message: 'Number should be between 0-99999',
              },
            ]}
          >
            <Input
              onChange={(e: { target: { value: string } }) => {
                setData(
                  'rulenumber',
                  i,
                  e.target.value,
                  rulenumber,
                  detailData,
                  setRuleNumber
                );
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={18}>
          <Form.Item
            label="Rule Description"
            name="ruledescription"
            rules={[
              {
                max: 19,
                message: 'You have reached the max character length of 19',
              },
              {
                required: true,
                message: 'This field is required',
              },
            ]}
          >
            <TextArea
              maxLength={19}
              edit={isonEdit}
              rows={1}
              onChange={(e: { target: { value: string } }) => {
                setData(
                  'ruledescription',
                  i,
                  e.target.value,
                  ruledescription,
                  detailData,
                  setRuledescription
                );
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item
            label="Minimum Age"
            name="minimumage"
            rules={[
              {
                pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                message: 'This field should be a number',
              },
            ]}
          >
            <Input
              onChange={(e: { target: { value: string } }) => {
                setData(
                  'minimumage',
                  i,
                  e.target.value,
                  minimumage,
                  detailData,
                  setMinimumage
                );
              }}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Maximum Age"
            name="maximumage"
            rules={[
              {
                pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                message: 'This field should be a number',
              },
            ]}
          >
            <Input
              onChange={(e: { target: { value: string } }) => {
                setData(
                  'maximumage',
                  i,
                  e.target.value,
                  maximumage,
                  detailData,
                  setMaximumage
                );
              }}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Extra Adult Charge"
            name="extraadultcharge"
            rules={[
              {
                pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                message: 'This field should be a number',
              },
            ]}
          >
            <Input
              onChange={(e: { target: { value: string } }) => {
                setData(
                  'extraadultcharge',
                  i,
                  e.target.value,
                  extraadultcharge,
                  detailData,
                  setExtraadultcharge
                );
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item
            label="Adult Rollaway"
            name="adultrollaway"
            rules={[
              {
                pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                message: 'This field should be a number',
              },
            ]}
          >
            <Input
              onChange={(e: { target: { value: string } }) => {
                setData(
                  'adultrollaway',
                  i,
                  e.target.value,
                  adultrollaway,
                  detailData,
                  setAdultrollaway
                );
              }}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Extra Child Charge"
            name="extrachildcharge"
            rules={[
              {
                pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                message: 'This field should be a number',
              },
            ]}
          >
            <Input
              onChange={(e: { target: { value: string } }) => {
                setData(
                  'extrachildcharge',
                  i,
                  e.target.value,
                  extrachildcharge,
                  detailData,
                  setExtrachildcharge
                );
              }}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Child Rollaway"
            name="childrollaway"
            rules={[
              {
                pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                message: 'This field should be a number',
              },
            ]}
          >
            <Input
              onChange={(e: { target: { value: string } }) => {
                setData(
                  'childrollaway',
                  i,
                  e.target.value,
                  childrollaway,
                  detailData,
                  setChildrollaway
                );
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item
            label="Service Charge"
            name="servicecharge"
            rules={[
              {
                pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                message: 'This field should be a number',
              },
            ]}
          >
            <Input
              onChange={(e: { target: { value: string } }) => {
                setData(
                  'servicecharge',
                  i,
                  e.target.value,
                  servicecharge,
                  detailData,
                  setServicecharge
                );
              }}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Crib Charge"
            name="cribcharge"
            rules={[
              {
                pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                message: 'This field should be a number',
              },
            ]}
          >
            <Input
              onChange={(e: { target: { value: string } }) => {
                setData(
                  'cribcharge',
                  i,
                  e.target.value,
                  cribcharge,
                  detailData,
                  setCribcharge
                );
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

const Policies_Extra = (props: propsTypes) => {
  const [dinamycMargin, setDinamycMargin] = useState<number>(60);
  //must rerender Collapse after add as we need new active keys
  const [refreshCount, setRefreshCount] = useState(0);
  const [detailData, setDetailData] = useState<detailDataType>(defaultRow);
  const [isonEdit, setIsOnEdit] = useState<boolean>(false);
  const [rulenumber, setRuleNumber] = useState<string[]>([]);
  const [ruledescription, setRuledescription] = useState<string[]>([]);
  const [startdate, setStartdate] = useState<string[]>([]);
  const [enddate, setEnddate] = useState<string[]>([]);
  const [adultrollaway, setAdultrollaway] = useState<string[]>([]);
  const [childrollaway, setChildrollaway] = useState<string[]>([]);
  const [cribcharge, setCribcharge] = useState<string[]>([]);
  const [extraadultcharge, setExtraadultcharge] = useState<string[]>([]);
  const [extrachildcharge, setExtrachildcharge] = useState<string[]>([]);
  const [servicecharge, setServicecharge] = useState<string[]>([]);
  const [maximumage, setMaximumage] = useState<string[]>([]);
  const [minimumage, setMinimumage] = useState<string[]>([]);
  const [ready, setReady] = useState<boolean>(false);
  const [isDisable, setIsDisabled] = useState<boolean>(false);
  const [disableDelete, setDisableDelete] = useState(true);
  const [dateError, setDateError] = useState<{}[]>([
    { startVal: 'success', endVal: 'success' },
  ]);

  const formTemp: any = useRef([]);

  //only need to change data which can controlling Panel rendering
  const deleteItem = (index: number) => {
    const _dateErrors = JSON.parse(JSON.stringify(dateError));
    _dateErrors.splice(index, 1);

    const _detailData = JSON.parse(JSON.stringify(detailData));
    _detailData.splice(index, 1);

    if (_detailData[index]) {
      setData(
        'startdate',
        index,
        _detailData[index]['startdate'],
        startdate,
        detailData,
        setStartdate
      );
      setData(
        'enddate',
        index,
        _detailData[index]['enddate'],
        enddate,
        detailData,
        setEnddate
      );
    }

    setDateError(_dateErrors);
    setDetailData(_detailData);
    // setting up margin bottom on empty emails
    if (_detailData.length < 1) {
      setDinamycMargin(90);
    }
  };

  //need add object and refresh active keys of <Collapse />, which means we need to rerender <Collapse />
  const addItem = useCallback(() => {
    const newDetails = Object.assign(detailData, [
      ...detailData,
      {
        rulenumber: '',
        ruledescription: '',
        startdate: '',
        enddate: '',
        adultrollaway: '',
        childrollaway: '',
        cribcharge: '',
        extraadultcharge: '',
        extrachildcharge: '',
        servicecharge: '',
        maximumage: '',
        minimumage: '',
      },
    ]);

    setData(
      'startdate',
      newDetails.length - 1,
      '',
      startdate,
      detailData,
      setStartdate
    );
    setData(
      'enddate',
      newDetails.length - 1,
      '',
      enddate,
      detailData,
      setEnddate
    );
    checkDateErrors(newDetails.length - 1, 'success', 'success');
    setDetailData(newDetails);
    setRefreshCount(refreshCount + 1);
    setDinamycMargin(60);
  }, [detailData, refreshCount]);

  const getPolicies = useCallback(async () => {
    /* istanbul ignore next */
    try {
      const dt: any = await getHelper('/property/policies');
      const response: any = dt.property;
      // if eservice id used in order to identify if it is a post or put call
      if (response.policies.extracharges) {
        const records = response.policies?.extracharges;
        // setting up the records data
        if (records.length > 0) {
          records.map((item: any, i: number) => {
            setData(
              'startdate',
              i,
              item['startdate'],
              startdate,
              records,
              setStartdate
            );
            setData(
              'enddate',
              i,
              item['enddate'],
              enddate,
              records,
              setEnddate
            );
          });
          setDisableDelete(false);
          setDetailData(records);
        } else {
          // setting up a default view
          const tempDetailData = {
            rulenumber: '',
            ruledescription: '',
            startdate: '',
            enddate: '',
            adultrollaway: '',
            childrollaway: '',
            cribcharge: '',
            extraadultcharge: '',
            extrachildcharge: '',
            servicecharge: '',
            maximumage: '',
            minimumage: '',
          };

          setDetailData([tempDetailData]);
        }
        setReady(true);
      }
    } catch (error) {
      /* istanbul ignore next */
      return error;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const persitingData = async () => {
    try {
      setIsDisabled(true);
      setReady(false);
      await post(detailData);
      setIsOnEdit(!isonEdit);
      props.setOperationType('view');
      setIsDisabled(false);
      setDisableDelete(!disableDelete);
      return setReady(true);
    } catch (error) {
      setReady(true);
      throw new Error('Error in posting data');
    }
  };

  const getFromServer = async () => {
    const response: policiesType = await getHelper('/property/policies');
    const records = response?.property?.policies?.extracharges;
    if (records && records.length > 0) {
      setDisableDelete(false);
      return setDetailData(records);
    }
    const cleanRow = [
      {
        rulenumber: '',
        ruledescription: '',
        startdate: '',
        enddate: '',
        adultrollaway: '',
        childrollaway: '',
        cribcharge: '',
        extraadultcharge: '',
        extrachildcharge: '',
        servicecharge: '',
        maximumage: '',
        minimumage: '',
      },
    ];
    return setDetailData(cleanRow);
  };

  const onDelete = async () => {
    setReady(false);

    detailData.splice(1);

    detailData[0]['rulenumber'] = '';
    detailData[0]['ruledescription'] = '';
    detailData[0]['startdate'] = '';
    detailData[0]['enddate'] = '';
    detailData[0]['adultrollaway'] = '';
    detailData[0]['childrollaway'] = '';
    detailData[0]['cribcharge'] = '';
    detailData[0]['extraadultcharge'] = '';
    detailData[0]['extrachildcharge'] = '';
    detailData[0]['servicecharge'] = '';
    detailData[0]['maximumage'] = '';
    detailData[0]['minimumage'] = '';
    const emptydata: detailDataType = [];

    await post(emptydata);

    formTemp.current.map((form: any) => {
      return form.resetFields();
    });
    setIsOnEdit(!isonEdit);
    setDisableDelete(!disableDelete);
    props.setOperationType('view');
    setReady(true);
  };

  const onClickCancel = async () => {
    setReady(false);
    await getFromServer();
    setIsOnEdit(!isonEdit);
    props.setOperationType('view');
    setReady(true);
  };

  const validateData = useCallback((form) => {
    form
      .validateFields()
      .then((values: { errorFields: string | any[] }) => {
        return setIsDisabled(values?.errorFields?.length > 0);
      })
      .catch((error: { errorFields: string | any[] }) => {
        return setIsDisabled(error?.errorFields?.length > 0);
      });
  }, []);

  const validateFormsData = useCallback(() => {
    if (!formTemp.current) return;
    formTemp.current.map((form: any) => {
      return form
        .validateFields()
        .then((values: { errorFields: string | any[] }) => {
          return setIsDisabled(values?.errorFields?.length > 0);
        })
        .catch((error: { errorFields: string | any[] }) => {
          return setIsDisabled(error?.errorFields?.length > 0);
        });
    });
  }, []);

  useEffect(() => {
    getPolicies();
  }, [getPolicies]);

  useEffect(() => {
    if (refreshCount) validateFormsData();
  }, [refreshCount, validateFormsData]);

  useEffect(() => {
    validateFormsData();
  }, [dateError]);

  const checkDateErrors = (i: number, startVal: string, endVal: string) => {
    let items = [...dateError];
    let item = { ...items[i], startVal: startVal, endVal: endVal };
    items[i] = item;
    setDateError(items);
  };

  const onChangeStartDate = (e: Moment, i: number) => {
    // const enddate: Moment = form.getFieldValue('enddate');
    if (!e) {
      setData('startdate', i, '', startdate, detailData, setStartdate);
      if (enddate[i] !== '' && enddate[i] !== null) {
        checkDateErrors(i, 'error', 'success');
      } else {
        checkDateErrors(i, 'success', 'success');
      }
      return;
    }

    let start = moment(e).format(dateFormat);

    setData('startdate', i, start, startdate, detailData, setStartdate);

    if (!(enddate[i] !== '' && enddate[i] !== null) || e.isBefore(enddate[i])) {
      checkDateErrors(i, 'success', 'success');
    } else {
      checkDateErrors(i, 'error', 'success');
    }
  };

  const onChangeEndDate = (e: Moment, i: number) => {
    if (!e) {
      setData('enddate', i, '', enddate, detailData, setEnddate);
      checkDateErrors(i, 'success', 'success');
      return;
    }
    let end = moment(e).format(dateFormat);
    setData('enddate', i, end, enddate, detailData, setEnddate);
    if (startdate[i] === '' || startdate[i] === null) {
      checkDateErrors(i, 'success', 'error');
    } else if (e.isAfter(startdate[i])) {
      checkDateErrors(i, 'success', 'success');
    } else {
      checkDateErrors(i, 'success', 'error');
    }
  };

  return (
    <PageContainer>
      <Card
        style={{ marginTop: -15, marginBottom: 50 }}
        extra={
          <Button
            type="primary"
            className={!isonEdit ? 'db-edit-btn' : 'd-none'}
            onClick={() => {
              setIsOnEdit(true);
              props.setOperationType('edit');
              validateFormsData();
            }}
          >
            Edit
          </Button>
        }
      >
        <Collapse
          defaultActiveKey={detailData.map((_: object, i: number) => i)}
          key={refreshCount}
          style={{ marginBottom: dinamycMargin }}
          multiCollapseButton
        >
          <>
            {ready &&
              detailData.map((item: itemType, i: number) => (
                <React.Fragment key={i}>
                  {item ? (
                    <Panel
                      header={`Extra Charge ${i + 1}`}
                      key={i}
                      deleteButton={
                        i !== 0 &&
                        isonEdit && {
                          action: () => deleteItem(i),
                          title: `Are you sure you want to delete Extra Charge ${
                            i + 1
                          }?`,
                        }
                      }
                    >
                      {
                        <Forms
                          isonEdit={isonEdit}
                          item={item}
                          i={i}
                          dateError={dateError}
                          rulenumber={rulenumber}
                          detailData={detailData}
                          setRuleNumber={setRuleNumber}
                          ruledescription={ruledescription}
                          setRuledescription={setRuledescription}
                          minimumage={minimumage}
                          setMinimumage={setMinimumage}
                          maximumage={maximumage}
                          setMaximumage={setMaximumage}
                          extraadultcharge={extraadultcharge}
                          setExtraadultcharge={setExtraadultcharge}
                          adultrollaway={adultrollaway}
                          setAdultrollaway={setAdultrollaway}
                          extrachildcharge={extrachildcharge}
                          setExtrachildcharge={setExtrachildcharge}
                          childrollaway={childrollaway}
                          setChildrollaway={setChildrollaway}
                          servicecharge={servicecharge}
                          setServicecharge={setServicecharge}
                          cribcharge={cribcharge}
                          setCribcharge={setCribcharge}
                          validateData={validateData}
                          formTemp={formTemp}
                          onChangeStartDate={onChangeStartDate}
                          onChangeEndDate={onChangeEndDate}
                        />
                      }
                    </Panel>
                  ) : null}
                </React.Fragment>
              ))}
            {!ready && <Loader type="medium" />}
            {isonEdit && (
              <div>
                <Button
                  type="link"
                  onClick={(e) => {
                    e.preventDefault();
                    addItem();
                  }}
                  icon={<PlusOutlined />}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: '#fff',
                    float: 'right',
                  }}
                >
                  {`Add Extra Charge${detailData.length + 1}`}
                </Button>
              </div>
            )}
          </>
        </Collapse>
        <ActionButtonsBar
          onCancel={onClickCancel}
          onSave={persitingData}
          disabledDelete={disableDelete}
          onDelete={onDelete}
          disabledSave={isDisable}
          show={isonEdit}
        />
      </Card>
    </PageContainer>
  );
};

export default Policies_Extra;
